<template>
  <v-select v-model="odabranaUslugaKljuc"
            :items="UslugeZaSeminarski"
            item-text="Ime"
            item-value="UpisPO_ID"
            @change="odabir(odabranaUsluga)"
            :label="$t('documents.upload.available_services')"></v-select>

</template>

<script>
  export default {
    name: 'SeminarUploadSelect',
    props: {
      odabir: {
        type: Function
      },
      setLoader: { type: Function }
    },

    computed: {
      odabranaUsluga() {
        return this.UslugeZaSeminarski.filter(x => x.UpisPO_ID == this.odabranaUslugaKljuc)[0];
      }
    },

    mounted() {
      this.getPodatkeZaUploadSeminarskog();
    },

    data() {
      return {
        loading: false,
        odabranaUslugaKljuc: null,
        UslugeZaSeminarski: []
      }
    },

    methods: {
      async getPodatkeZaUploadSeminarskog() {
        var self = this;
        this.setLoader(true);
        var data = { GetSamoStatuse: false };
        var result = await this.$fetchDataPromise('/api/Documents/GetPodatkeZaUploadSeminarskog', data).catch(x => { this.setLoader(false); this.$displayError(x); });
        this.UslugeZaSeminarski = result.map(x => {
          var obj = x;
          var istekao = x.UpisIstekao ? ` (${self.$t('documents.upload.enrollment_expired')})` : '';
          obj.Ime = x.Ime + istekao;
          return obj;
        });
        this.setLoader(false);
      },
    }


  }
</script>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/SeminarUploadSelect.vue